<template>
    <div class="hello" style="">

         <div class="menu-row">
            <t-back-button :to="{name:'TThinkPage'}" />
         </div>

          <button class="t-button" @click="PrintPage();"> <i class="fas fa-print" ></i>印刷する</button>

  <!-- <div class="print-area"> -->

 
        <!-- =========================
      １ページ目
      =========================-->
    <section class="sheet">
      <!-- =========================
      タイトル 
      =========================-->

      <title-component class="c-title" :title="thinkData.title" style="margin-bottom:10px;" />
      <!-- =========================
      言葉一覧
      =========================-->
      <div class="container">
        <div class="words">
          <div
            v-bind:class="{contain: ContainContents(item),disable:item.isLoading,selected: currentWord != null && item.id === currentWord.id}"
            :key="item.id"
            v-for="(item,index) in words"
            class="word-box"
          >
            <span>
              <i v-show="ContainContents(item)" class="fas fa-comment-dots"></i>
              <span class="number">{{index + 1}}</span>
              <span class="word-item">{{ item.main }}</span>
            </span>
          </div>
        </div>
      </div>
     

    </section>


      <!-- =========================
      2ページ目
      =========================-->
    <section class="sheet" style="margin-top:20px;">

      <title-component class="c-title" :title="thinkData.title" style="margin-bottom:10px;" />
      <tthink-component class="tthink" :readonly="true" :autoGrow="true" title="こにゃにちわ"/>
    </section>

     <!-- </div> -->


  </div>
</template>



<script>
import Title from "../atoms/Title";
import TThink from "../organisms/TThinkEditor";
import TBackButton from "../atoms/TBackButton";
export default {
  name: "PrintPage",
  components: {
    "title-component": Title,
    "tthink-component": TThink,
    TBackButton
  },
  props:{
    thinkID:String,
    wordID:String
    },
  computed: {
    thinkData() {
      return this.$store.getters.thinkData;
    },
    words: {
     

     get() {

       if(this.$store.getters.thinkData.words.length>0)
       {
          // setTimeout(function(){
          //         window.print()
                
          //       }, 2000)
       }
         

        return this.$store.getters.thinkData.words;
      }
    }
  },
  

  methods: {
    ContainContents(item) {
      if (item.really === "" && item.so === "" && item.why === "") {
        return false;
      }
      return true;
    },
    PrintPage(){
       window.print() 
        //setTimeout(window.print, 1000);
    }
  },
   mounted() {

    //$("meta[name='viewport']").attr('content', 'width=1080');

    window.scrollTo(0,0);//スクロールをトップにもっていく


    //Notice: storeのthinkDataがセットされていない場合
    //1.think一覧を取得
    //2.現在のthinkIDと照合するかチェック
    //3.照合する＝StoreにSetThinkし、GetWordsを実行
    //3.照合NG = thinkpageへリダイレクト
    //4-1.取得したwordsデータを照合し、OKだったらSetActiveWord,NGだったらword一覧へ戻る
    if (this.thinkData.id === undefined) {
      var callback = function(result,msg) {
        if(result === false)
        {
          alert(msg)
          return;
        }
        var items = this.$store.getters.thinkItems;
        var itemsCount = items.length;
        for(var i = 0; i < itemsCount; i++) {
          if(items[i].id=== this.thinkID)
          {
            //照合OK:選択
             this.$store.commit("SetThink", items[i]);

             //選択したデータの[Words]を取得する
             var callbackGetWords = function(result,msg)
             {
                var isExistWord = false;
                var result = this.$store.getters.thinkData.words.filter( function( item,index ) {
                    //word照合:OK
                    if(item.id === this.wordID)
                    {
                      item.index = index + 1;//Notice:ここでSEQをセットしないと、表示が「０」になる
                      this.$store.commit("SetActiveWord", item);
                      isExistWord= true;
                      return true
                    }
                  }.bind(this))

                  //word照合:NG=指定のIDのwordが存在しない
                  //=words一覧へもどる
                  if(isExistWord === false)
                  {
                    this.$router.push({ name: "WordsPage",params:{thinkID:this.thinkData.id} });
                  }
             }.bind(this)
             this.$store.dispatch("GetWords",{callback:callbackGetWords});
             return;
          }
        }

        //照合NG
        //データが存在しない場合はthinkpageへリダイレクト
         if (this.thinkData.id === undefined) {
            this.$router.push({ path: "/thinkpage" });
            return;
        }

      

       
      }.bind(this);

      //1.think一覧を取得
      this.$store.dispatch("GetThinks",{callback:callback});

     

    }


     



  },
  beforeCreate: function() {
    //document.body.className = 'landing';
  },
  beforeDestroy() {
    //document.body.className = '';
  }
};
</script>


<style scoped lang="scss">
@import "../../assets/style/common.scss";


/* プレビュー用のスタイル */
@media screen {

  .sheet {
    padding:40px;
    background: white; /* 背景を白く */
    box-shadow: 0 .5mm 2mm rgba(0,0,0,.3); /* ドロップシャドウ */
    margin: 5mm;
    position: relative;
    width: 210mm;
    min-height: 296mm; /* 1mm余裕をもたせる */
  }

}


// hr.pagebreak{

// page-break-after: always;
// }

.sheet {
  page-break-after: always;
  //page-break-inside: avoid;//改ページ時、文字が途中でとぎれないようにする設定



//  &:nth-of-type(1)
//   {
  
//     //page-break-after: avoid;
//   }


//   &:nth-of-type(2)
//   {
//     //page-break-before: always;
//     page-break-inside: avoid;//改ページ時、文字が途中でとぎれないようにする設定
//   }
  
   
  
}

.print-area{
  width:100%;
  display: block;
  overflow:scroll;
//   transform-origin:top left;
// transform: scale(0.46);
}

.menu-row{
  display:flex;
  justify-content: start;
  align-items: center;
  margin-left: 5mm;
  width: 230mm;
  @media print{
   display: none;
   }


  
}


.t-button {
    position:fixed;
    bottom:20px;
    left:90px;
    z-index:999;
      cursor: pointer;
      color: #fff;
      padding-left:25px;
      padding-right:25px;
      display: inline-block;
      border: none;
      margin-left:auto;
      background:#42b983;
      text-align: center;
      border-radius: 25px;
      padding-top: 14px;
      padding-bottom: 15px;
      //margin-top:-15px;
      vertical-align: middle;
      letter-spacing: 0.03em;
      font-weight: 600;
      font-size: 22px;
      transition: all 200ms 0s ease;

      box-shadow: 0px 4px #257e56;

      // -文字を選択させない
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;

       @media print{
   display: none;
   }
      

       &:hover {
      background:#308f64;
    }



      & >i{
        margin-right:6px;
      }

}



.container {
  display: flex;
  position: relative;
  background: #f2faf6;
  border: 2px solid #666;
  align-items: stretch;
  border-radius: 16px;
}

//=====================
//
//=====================
.words {
  padding: 15px 20px 30px 20px;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  align-items: flex-start;
  min-height: 200px;
}

//=====================
//
//=====================
.word-box {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;

  // -文字を選択させない
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;

  // OSブラウザでタップした要素が自動的に暗くなるのを防止する
  -webkit-tap-highlight-color: transparent;

  border-radius: 10px;
  padding-top: 6px;
  padding-bottom: 4px;
  padding-left: 20px;
  padding-right: 25px;
  background-color: white;
  color: #333333;
  display: inline-block;
  margin-left: 8px;
  margin-top: 10px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #39af78;
  box-shadow: 0px 1px #39af78;

  & > p {
    margin: 50px;
    padding: 0;
  }
  .number {
    font-weight: normal;
    font-size: 12px;
    margin-right: 5px;
    color: #39af78;
  }
  //:データを含んでいる言葉のスタイル
  &.contain {
    font-size: 16px;
    font-weight: 800;
    //background: #71BAD8;
    background: #39af78;
    color: white;
    text-shadow: 1px 2px 0px #666;
    .btn-delete {
      & > i {
        background: #39af78;
      }
      &:hover {
        color: white;
        & > i {
          background: coral;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/pages/PrintPage.vue